/* RESPONSIBLE TEAM: team-standalone */

import Service from '@ember/service';
import { FrameComposerType } from 'embercom/lib/frame-adapter';
import { tracked } from 'tracked-built-ins';
// @ts-ignore
import { dedupeTracked } from 'tracked-toolbox';
export default class CopilotFrameService extends Service {
  @dedupeTracked composerHasContent = false;
  // composer should always be visible for Zendesk
  // but we sometimes can't detect it for custom Salesforce installations
  // we use this flag to let them copy copy copilot answers to their clipboard
  @tracked composerVisible = true;
  @tracked composerType: FrameComposerType = FrameComposerType.PUBLIC;
}

declare module '@ember/service' {
  interface Registry {
    copilotFrameService: CopilotFrameService;
    'copilot-frame-service': CopilotFrameService;
  }
}
